export default function ArticlePromo() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="rounded-lg border border-background-200/70 bg-background-50 p-8 md:p-10">
          <div className="flex flex-col lg:flex-row items-center gap-8">
            <div className="flex-1 min-w-0">
              <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold uppercase tracking-wider mb-4">
                In-Depth Guide
              </span>
              <h3 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-3">
                The Ultimate Sugargoo Spreadsheet Guide
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-6">
                Dive deep into everything Sugargoo Spreadsheet — from setting up your first product discovery workflow to advanced tips for finding the best deals, comparing sellers like a pro, and maximizing your savings on every order. This comprehensive guide covers all 14 product categories, shipping strategies, QC best practices, and exclusive community resources.
              </p>
              <a
                href="/article/sugargoo-spreadsheet-ultimate-guide"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-white hover:bg-primary-600 text-sm font-semibold transition-all cursor-pointer whitespace-nowrap"
              >
                Read Full Guide
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
            <div className="w-full lg:w-72 h-48 lg:h-56 rounded-lg overflow-hidden flex-shrink-0">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20desk%20with%20an%20open%20laptop%20displaying%20organized%20product%20spreadsheet%20grid%20with%20small%20colorful%20product%20images%20and%20ratings%2C%20warm%20cream%20and%20beige%20background%2C%20soft%20natural%20sunlight%20from%20window%2C%20coffee%20cup%20on%20side%2C%20clean%20organized%20workspace%20aesthetic%2C%20editorial%20photography%2C%20light%20wood%20desk%20with%20subtle%20texture%2C%20peaceful%20productive%20atmosphere&width=600&height=450&seq=article-promo-v3&orientation=landscape"
                alt="Ultimate Sugargoo Spreadsheet Guide preview"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}